export default {
  "hvac-1n3jw": "North America Equipments",
  "equipements-france": "France Equipments",
  equipment_type: {
    "membrane_flashing": "Membrane flashing",
    "equipment_base": "Equipment base",
    "insulated_parapet": "Insulated parapet",
    "metal_flashing": "Metal flashing",
    "cap_metal_flashing": "Cap metal flashing",
    "drain": "Drain",
    "overflow": "Overflow",
    "vault": "Vault",
    "skylight": "Skylight",
    "fix_skylight": "Fix skylight",
    "opening_skylight": "Opening skylight",
    "double_opening_skylight": "Double opening skylight",
    "counter-cladding": "counter-cladding",
    "safety_post": "Safety post",
    "safety_cable": "Safety cable",
    "guard_rail": "Guard rail",
    "goose_neck": "Goose neck",
    "water_lock": "Water lock",
    "ventilation": "Ventilation",
    "slope": "Slope",
    "rooftop": "Rooftop",
    "smoke_conduct": "Smoke conduct",
    "motor_and_equipment": "Motor and equipment",
    "motor_equipment": "Motor equipment",
    "single_expansion_joint": "Single expansion joint",
    "double_expansion_joint": "Double expansion joint",
    "gravel_stop": "Gravel stop",
    "edge_strip_sewer": "Edge strip/sewer",
    "drip_gutter": "Drip or gutter",
    "generic_object": "Generic object",
    "drip": "Drip"
  },
  menu: {
    roof_section: "Roof Sections",
    equipments: "Equipments",
    projects: "Projects",
    new_project: "New Project",
    project_list: "Project List",
    add_roof_section: "Roof Section",
    filters: "Filters",
    add_project: "Add Project",
    unit_scale: "Unit Scale",
    add_equipment: "Add Equipment",
    add_note: "Add Note",
    assets: "Assets",
    hand: "Hand",
    help: "Help",
    placeholder: {
      search: "Search",
      unit_scale: "Unit Scale"
    },
    copy: "Copy",
    back: "Back",
    properties: "Properties",
    assign_divlato_code: "Assign Divlato Code",
  },
  modal: {
    help: {
      zoom: `Use <code>Mouse Wheel</code> for Zoom-In/Zoom-out`,
      drag: `Use <code>Mouse Drag</code> to move around in Canvas`,
      esc: `Press <code>ESC</code> to cancel polygon drawing`
    }
  },
  sidebar: {
    titles: {
      roof_section: "Roof Section",
      equipment: "Equipments",
      added_equipment: "Added Equipments",
      assets_list: "Assets List",
      identification: "Auto Indentification Setup",
      equipment_details: "Equipment Details",
      roof_details: "Roof Details",
      project_settings: 'Project settings',
      project_group_threshold: "Group the equipments",
      threshold_definition: "Group the similar equipments which dimension have difference less than"
    },
    label: {  
      roof_sections: "Roof Sections",      
      added_equipments: "Added Equipments",
      filter: "Filter",
      total_perimeter: "Total Perimeter",
      draggable: "Draggable",
      auto_set_shape: "Auto set shape",
      perimeter: "Perimeter",
    },
    heading: {
      label: "Label",
      perimeter: "Perimeter",
      area: "Raw area",
      net_area: "Net area",
      equip_count: "Equip. Count",
      action: "Action",
      icon: "Icon",
      equipment: "Equipment",
      utilities: "Utilities",
      width: "Width",
      length: "Length",
      skylight_type: "Skylight type",
      height: "Height",
      ply_count: "Ply count",
      nature: "Nature",
      drawing_type: "Drawing type",
      flashing_type: "Flashing type",
      kind: "Kind",
      shape: "Shape",
      other: "Other",
      flashing: "Flashing",
      engraving: "Engraving",
      cover: "Cover",
      entablature: "Entablature",
      vertical: "Vertical",
      horizontal: "Horizontal",
      diameter: "Diametre",
      rectangular: "Rectangle",
      cylindrical: "Cylindrical",
      quantity: "Count",
      report_on_roof_sections_and_equipment: "Report on Roof Sections and Equipment",
    },
    placeholder: {
      search: "Type to Search"
    }
  },
  project_headings:{
    name: "Project Name",
    address: "Address",
    asset_type: "Asset Type",
    asset_status: "Asset Status",
    scale: "Scale",
    created_at: "Created At"
  },
  project_status: {
    ready: "ready",
    pending: "pending",
    draft: "draft",
    uploaded: "uploaded",
    set: "set",
    notset: "not set"
  },
  project_form: {
    labels: {
      pdf: "New Project using PDF",
      drone: "New project using drone",
      using: "Are you using",
      name_field: "Project Name",
      date_field: "Inspection Date",
      agency_field: "Assign Agency",
      client_field: "Client Organization",
      address_field: "Building Address",
      heading: "Project details"
    },
    placeholder: {
      name_field: "Enter Name of New Project",
      client_field: "Select Client",
      address_field: "Search on Google Maps"
    },
  },
  errors: {
    required: "This is required."
  },
  upload_form: {
    dnd_pdf: "Drag or Drop PDF",
    dnd_zip: "Drag or Drop Zip"
  },
  table_headings: {
    name: "Name",
    shape_type: "Shape Type",
    color: "Color"
  },
  general: {
    or: "or",
    new: "New",
    cancel: "Cancel",
    save: "Save",
    home: "Home"
  },
  warnings: {
    reset_project_analysis: "Warning, you already used AI detection, if you click again without deleting the first equipment detected you may have double equipment appearing",
    roof_creation_info_text: "Caution, when drawing a new roof section around equipment, it may take 1 or 2 minutes to see equipments belonging to that roof section"
  },
    grouping: {
    title: "Grouping rules",
    ruleName: "Rule Name",
    minPerimeter: "Min Perimeter",
    maxPerimeter: "Max Perimeter",
    addRule: "Add Rule",
    generateReport: "Generate Report",
    note: "Rules modified here are temporary and will not be saved permanently.",
    noRulesFound: "No rules found."
  }
}
